<!--    
@author zhijie.huang
@date 2018/9/29
@version v1.1.0
@description siteList 站点列表
-->
<template>
  <div class="siteList__content">
    <el-button style="margin-bottom: 16px;" type="primary" @click="e_add" v-g-rac="gRac('siteList_add')">{{ $t('common.add') }}</el-button>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      id="siteList"
      key="siteEdit"
      :title="dialogTitle" 
      :size="1" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogForm"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="isAdd ? e_saveConfirm : e_updateConfirm">
    </dialog-form>

    <dialog-detail
      key="siteDetail"
      :title="dialogTitle" 
      :size="2" 
      :label-size="2" 
      :visible.sync="dialogDetailShow" 
      :model="dialogDetailModel"
      :detail-data="dialogData"
      :cancel-fun="e_detailCancel">
    </dialog-detail>
  
  </div>
</template>

<script>
import rac from '@/plugins/rac-mixin'
import dic from '@/components/mixins/dic'
import table from '@/components/mixins/table'
import SiteListBiz from '@/logic/cmdb/cmdbBiz'
import dialogForm from '@/components/dialogForm'
import dialogDetail from '@/components/dialogDetail'
import validateConfig from '@/utils/validate'

export default {
  mixins: [rac, dic, table],
  data () {
    const that = this
    return {
      isAdd: true,
      dialogTitle: '',
      dialogFormShow: false,
      dialogDetailShow: false,
      dialogData: [],
      dialogForm: {
        id: '',
        name: '',
        siteCode: '',
        siteType: '',
        network: '',
        bandWidth: '',
        contact: '',
        phone: '',
        address: '',
        accessId: '',
        secretKey: '',
        ec2endpoint: '',
        ipAddrSegment: '',
        remarks: ''
      },
      dialogDetailModel: {},
      dialogFormRule: {},
      tableControl: [
        {
          label: that.$t('common.edit'),
          callback: that.e_update
        }, {
          label: that.$t('common.check'),
          callback: that.e_detail
        }, {
          label: that.$t('common.delete'),
          callback: that.e_delete
        }]
    }
  },
  components: {
    dialogForm,
    dialogDetail
  },
  methods: {
    initTable () {
      this.tInitTable({
        lanKey: 'siteList.table',
        head: ['name', 'siteCode', 'address', 'network', 'bandWidth', 'contact', 'phone'],
        requestFun: this.search
      })
    },
    search (data) {
      SiteListBiz.siteList(data).then((data) => {
        this.tData = data
      }).catch((err) => {
        console.error(err)
      })
    },
    async preSetDialogData () {
      await this.dGetDictionaryByCode('siteType')
      this.setDialogData()
    },
    setDialogData () {
      this.dialogData = [
        {
          label: this.$t('siteList.table.id'),
          key: 'id',
          hidden: true
        },
        {
          label: this.$t('siteList.table.name'),
          key: 'name'
        },
        {
          label: this.$t('siteList.table.siteCode'),
          key: 'siteCode'
        },
        {
          label: this.$t('siteList.table.siteType'),
          key: 'siteType',
          type: 'select',
          select: this.dDictionary.siteType
        },
        {
          label: this.$t('siteList.table.network'),
          key: 'network'
        },
        {
          label: this.$t('siteList.table.bandWidth'),
          key: 'bandWidth'
        },
        {
          label: this.$t('siteList.table.contact'),
          key: 'contact'
        },
        {
          label: this.$t('siteList.table.phone'),
          key: 'phone'
        },
        {
          label: this.$t('siteList.table.address'),
          key: 'address'
        },
        {
          label: this.$t('siteList.table.accessId'),
          key: 'accessId',
          type: 'password'
        },
        {
          label: this.$t('siteList.table.secretKey'),
          key: 'secretKey',
          type: 'password'
        },
        {
          label: this.$t('siteList.table.ec2endpoint'),
          key: 'ec2endpoint',
          type: 'password'
        },
        {
          label: this.$t('siteList.table.ipAddrSegment'),
          key: 'ipAddrSegment'
        },
        {
          label: this.$t('siteList.table.remarks'),
          key: 'remarks',
          type: 'textarea'
        }
      ]
      const array = ['name', 'siteCode', 'siteType', 'network', 'bandWidth',
        'contact', 'phone', 'address', 'accessId', 'secretKey', 'ec2endpoint', 'ipAddrSegment']
      array.map((item) => {
        this.dialogFormRule[item] = [{ ...validateConfig.common.notEmpty }]
      })
    },
    e_update (row, index, data) {
      for (const key in this.dialogForm) {
        if (row[key]) {
          this.dialogForm[key] = row[key]
        }
      }

      this.dialogTitle = this.$t('common.edit')
      this.dialogFormShow = true
      this.isAdd = false
    },
    e_detail (row, index, data) {
      this.dialogTitle = this.$t('common.check')
      this.dialogDetailModel = row
      this.dialogDetailShow = true
    },
    e_detailCancel () {
      this.dialogDetailModel = {}
    },
    e_delete (row, index, data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        SiteListBiz.deleteSite({
          id: row.id
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.search()
        })
      }).catch(() => {

      })
    },
    e_add () {
      this.dialogTitle = this.$t('common.add')
      this.isAdd = true
      this.dialogFormShow = true
    },
    e_cancel () {
      for (const key in this.dialogForm) {
        this.dialogForm[key] = ''
      }
    },
    e_updateConfirm (data) {
      SiteListBiz.updateSite(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.dialogFormShow = false
        this.e_cancel()
        this.search()
      })
    },
    e_saveConfirm (data) {
      delete data.id
      SiteListBiz.addSite(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.dialogFormShow = false
        this.e_cancel()
        this.search()
      })
    }
  },
  mounted () {
    this.initTable()
    this.search()
    this.preSetDialogData()
  }
}
</script>
